import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import { useValidate } from "formvalidation/hooks";
import classNames from "classnames";
import React from "react";
import { isNullOrEmptyString } from "shared/utils";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props {
  firstName: string;
  insertion: string;
  lastName: string;

  onChange: (firstName: string, insertion: string, lastName: string) => void;
  onEnter?: () => void;
  onEsc?: () => void;
  width?: number
  className?: string;
  focusOnMount?: boolean;
}

export const ContactName = (props: Props) => {
  const { firstName, insertion, lastName, onChange } = props;

  const semanticRef = useSemanticUiInputRef();
  const validation = useValidate({
    key: "contactName",
    title: "Contact Name",
    value: [firstName, lastName],
    dependencies: [firstName, lastName],
    ref: semanticRef.ref,
    validate: async () => !isNullOrEmptyString(firstName) || !isNullOrEmptyString(lastName)
  });

  const parentClass = classNames("flex gap-small", props.className);
  const growClass = classNames({ grow1: props.width == null });

  return (
    <div className={parentClass}>
      <div className={growClass} style={{ width: props.width }}>
        <OptionalTextInput
          focusOnMount={props.focusOnMount}
          maxLength={serverReference.constants.personName.maxFirstNameLength}
          value={firstName}
          onChange={(value) => onChange(value, insertion, lastName)}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
          placeholder={RESX.Contact.FirstNameHelpText}
          innerRef={semanticRef}
          hasError={validation.error.hasError}
        />
      </div>
      <div className={growClass} style={{ width: props.width }}>
        <OptionalTextInput
          maxLength={serverReference.constants.personName.maxInsertionLength}
          value={insertion}
          onChange={(value) => onChange(firstName, value, lastName)}
          placeholder={RESX.Contact.MiddleNameHelpText}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
        />
      </div>
      <div className={growClass} style={{ width: props.width }}>
        <OptionalTextInput
          maxLength={serverReference.constants.personName.maxLastNameLength}
          value={lastName}
          onChange={(value) => onChange(firstName, insertion, value)}
          placeholder={RESX.Contact.LastNameHelpText}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
        />
      </div>
    </div>
  );
};